import { ceaser } from "./ceaser";


$(function() {

    // if the slide contains a video, make the video start from the begining
    $('.js-animation-carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide) {

        //if($(document).width() >= 1024){
            var $nextSlide = $(slick.$slides[nextSlide]);

            if ($nextSlide.find('video').length > 0) {

                var video = $nextSlide.find('video');
                video.get(0).currentTime = 0;

            }
       // }

    });

	$('.js-animation-carousel').slick({
		draggable:false,
		arrows: false,
        speed: 0,          
        cssEase: 'linear',
        fade: true, 
        useTransform:true,
        rows: 0, // Fix vor v1.8.0-1
        autoplay:false,
        autoplaySpeed:320
	});

});

$(document).on('start-animation', function() {
    $('.js-animation-carousel').slick('slickPlay');
});

$(document).on('stop-animation', function() {
    $('.js-animation-carousel').slick('slickPause');
    $('.js-animation-carousel').slick('slickGoTo', 0);
});

